import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import 'core-js'
import 'react-app-polyfill/stable'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './i18n/config'
import './index.scss'
import reportWebVitals from './reportWebVitals'
import { initSentry } from './sentry'
import { getNewToken } from './services/auth'
import store from './store'
import { RegionProvider } from './utils/context/RegionContext'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
    mutations: {
      retryDelay: (attempt) => Math.min(attempt > 1 ? 2 ** attempt * 1000 : 1000, 30 * 1000),
      retry: async (failureCount, error) => {
        const { message } = error
        const messageObj = JSON.parse(message)
        switch (messageObj.status) {
          case 403:
          case 401:
            const renewResult = await getNewToken()
            if (!renewResult.ok) {
              localStorage.clear()
              queryClient.invalidateQueries({ refetchType: 'none' })
              queryClient.clear()
              window.location.assign('/login')
              return false
            }
            const renewInfo = await renewResult.json()
            if (!renewInfo?.encodedToken) {
              localStorage.clear()
              queryClient.invalidateQueries({ refetchType: 'none' })
              queryClient.clear()
              window.location.assign('/login')
              return false
            }
            localStorage.setItem('token', renewInfo.encodedToken)
            return true
          default:
            return failureCount < 4
        }
      },
    },
  },
})

initSentry()

const container = document.getElementById('root')
const root = createRoot(container)

root.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <Provider store={store}>
        <RegionProvider>
          <App />
        </RegionProvider>
      </Provider>
    </BrowserRouter>
  </QueryClientProvider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
